<button class="jolojo-btn {type} {extraClass}"
  class:disabled
  class:rounded
  class:large
  class:small
  {disabled}
  on:click
>
  <slot></slot>
  {#if icon}
    <span class="material-icon normal-icon">{icon}</span>
    {#if hoverIcon}
      <span class="material-icon hover-icon">{hoverIcon}</span>
    {:else}
      <span class="material-icon hover-icon">{icon}</span>
    {/if}
  {/if}
</button>

<script>
  export let type = 'primary'
  export let icon = ''
  export let hoverIcon = ''
  export let rounded = false
  export let extraClass = ''
  export let disabled = false
  export let large = false
  export let small = false
</script>

<style lang="scss">.primary {
  background: #3b82f6;
  color: white;
}

.secondary {
  background: #6b7280;
  color: white;
}

.success {
  background: #28a744;
  color: white;
}

.danger {
  background: #ef4444;
  color: white;
}

.warning {
  background: #f59e0b;
  color: #111827;
}

.light {
  background: #f3f4f6;
  color: #111827;
}

.dark {
  background: #111827;
  color: white;
}

.outlined {
  background: #f3f4f6;
  color: #111827;
  outline: 1px solid #111827;
}

.jolojo-btn {
  padding: 8px 16px;
  width: min-content;
  height: min-content;
  flex: none;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
  border: none;
  cursor: pointer;
  transition: 0.3s;
}
.jolojo-btn.small {
  padding: 6px 12px;
  font-size: 12px;
}
.jolojo-btn.rounded {
  border-radius: 99999999999999px;
  padding: 6px;
}
.jolojo-btn.large {
  padding: 12px;
}
.jolojo-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.jolojo-btn .material-icon {
  font-family: "Material Icons";
  font-size: 16px;
}
.jolojo-btn.special {
  background: #b910a0;
  color: white;
}
.jolojo-btn .normal-icon {
  display: block;
}
.jolojo-btn .hover-icon {
  display: none;
}
.jolojo-btn:hover {
  filter: brightness(0.8);
}
.jolojo-btn:hover .normal-icon {
  display: none;
}
.jolojo-btn:hover .hover-icon {
  display: block;
}</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>